export const ROUTE_PATHS = {
  ROOT: '/',
  MATCH_ALL: '*',
  NEW: 'new',
  LOGIN: 'login',
  LOGOUT: 'logout',
  LOGIN_CALLBACK: 'implicit/callback',
  LOGIN_SESSION: 'login-session',
  ACTIVATE: 'activate',
  FORGOT_PASSWORD: 'forgot-password',
  SET_PASSWORD: 'set-password',
  HOME: '',
  SETTINGS: 'settings',
  SIGNAL: 'signal',
  CHAT: 'chat',
  SETTINGS_SIGNAL_FIELDS: 'signal-fields',
  SETTINGS_MEETING_FIELDS: 'meeting-fields',
  SETTINGS_EMAIL_FIELDS: 'email-fields',
  SETTINGS_EMAIL_BLACKLIST: 'email-blacklist',
  SETTINGS_EMAIL_INTELLIGENCE: 'email-intelligence',
  SETTINGS_SIGNAL_CONFIGURATION_LIST: 'signal-configurations',
  SETTINGS_SIGNAL_CONFIGURATION: 'signal-configurations/:signalId',
  ACCOUNTS: 'accounts',
  LIST: 'list',
  TEMPLATES: 'templates',
  MEETING_PAGE_TEMPLATES: 'meeting-templates/new',
  MEETING_PAGE_TEMPLATE_LIST: 'meeting-templates',
  MEETING_PAGE_TEMPLATE_EDIT: ':meetingPageTemplateId',
  COMPANY_PAGE_TEMPLATE_LIST: 'company-pages',
  COMPANY_PAGE_TEMPLATE_EDIT: ':companyPageTemplateId',
  PEOPLE_PAGE_TEMPLATE_LIST: 'people-page-templates',
  PEOPLE_PAGE_TEMPLATE_EDIT: ':peoplePageTemplateId',
  EMAIL_PAGE_TEMPLATE_LIST: 'email-templates',
  EMAIL_PAGE_TEMPLATE_EDIT: ':emailPageTemplateId',
  ACCOUNT_DETAIL: ':accountId',
  ACCOUNT_DETAIL_TIMELINE: 'timeline',
  ACCOUNT_DETAIL_MEETINGS: 'meetings/:meetingId?',
  ACCOUNT_DETAIL_EMAILS: 'emails/:emailId?',
  ACCOUNT_DETAIL_MEETING_EDIT: 'edit',
  ACCOUNT_DETAIL_EMAIL_EDIT: 'edit',
  ACCOUNT_DETAIL_PEOPLE: 'people',
  ACCOUNT_DETAIL_PEOPLE_LIST: 'list',
  ACCOUNT_DETAIL_PEOPLE_BOARD: 'board',
  ACCOUNT_DETAIL_PEOPLE_DETAIL: ':userId',
  ACCOUNT_DETAIL_SPACES: 'spaces/:spaceDocumentId?',
  ACCOUNT_DETAIL_SPACES_EDIT: 'edit',
  ACCOUNT_SIGNAL_BOARD: 'board',
  ACCOUNT_DOCUMENT: ':documentId/:mode',
  CHAT_LAYOUT: 'conversation/:conversationId',
  CHAT_LAYOUT_NEW: 'conversation/new',
  ALL_SIGNALS: 'all-signals',
  SIGNALS_V2: 'signals',
  AGENTS: 'agents',
  KNOWLEDGE_BASE: 'knowledge-base',
  KNOWLEDGE_BASE_FOLDER: 'folders/:folderId',
  AGENT_BUILDER: 'agent-builder',
  SIGNAL_AGENTS: 'signal-agents',
  SALESFORCE_INTEGRATION: 'integrations/salesforce',
  SALESFORCE_SETTINGS: 'settings/integrations/salesforce',
  SALESFORCE_SETTINGS_INTEGRATION:
    'settings/integrations/salesforce/:integrationId',
  SALESFORCE_AUTOMATIONS: 'automations',
  SALESFORCE_FIELD_SYNC: 'field-sync',
  SALESFORCE_ERROR_LOGS: 'error-logs',
  SALESFORCE_SETTINGS_TAB: 'settings',
} as const;
